// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo-preview[data-v-5ad00eb5]{height:22px;position:absolute;right:0}", ""]);
// Exports
module.exports = exports;
